// For production
// export const env = "https://hindici.com";
// export const basename = "/app";

// For local
// export const env = "http://localhost:5000";
// export const basename = "";

const isDevelopment = process.env.NODE_ENV === "development";

export const env = isDevelopment
  ? process.env.REACT_APP_API_URL || "http://localhost:5000"
  : "https://lobster-app-shkdy.ondigitalocean.app";

// export const env = "https://lobster-app-shkdy.ondigitalocean.app";

// export const env = "https://spinandwin.neveratech.com";

const defaultBasename = isDevelopment ? "" : "/app";
export const basename = process.env.REACT_APP_BASENAME || defaultBasename;

// export const env = process.env.REACT_APP_API_URL || "http://localhost:5000";
// export const basename = process.env.REACT_APP_BASENAME || "";
